<template>
  <v-card
    class="video-card mb-7"
    :class="'layout-' + this.layout + ' ' + (this.active ? 'active' : '')"
    outlined
    style="background-color: transparent; border: none"
  >
    <router-link :to="this.routerLinkTo" class="video-card__link">
      <div class="video-card__img-container">
        <v-img :src=videoPoster v-bind:class="{'video-card__overlay': active }">
          <v-chip v-if="newVideo" color="#e4087e" style="color: white; font-weight: bold; position: absolute; top: 3px; right: 2px; " small>NEW</v-chip>
          <div></div>
          <v-avatar color="white" >
              <v-img contain :src=themeLogo />
          </v-avatar>
        </v-img>
        <div v-if="active" class="video-card__overlay--text">
          {{$t('common.displayVideo')}}
        </div>
        <div>
          <b-progress height="4px" :value="lastSeen" :max="max" class="square-progress-bar"></b-progress>
          <!-- <span class="v-icon mdi mdi-check-bold"/> -->
        </div>
      </div>
    </router-link>

    <div class="video-card__content">
      <router-link :to="this.routerLinkTo">
        <v-card-title class="pa-0 mt-5 d-flex align-items-stretch" data-toggle="tooltip" data-placement="top" v-bind:title="this.video.title">
          <p class="truncate">{{ this.video.title }}</p>
        </v-card-title>
      </router-link>
      <v-card-subtitle style="margin-top:1px" class="title-truncate pa-0 mt-1 d-flex align-items-center">
        <a target="_blank" :href="this.video.partner ? this.video.partner.url : 'https://www.tellmegenius.io/'"> 
        <v-avatar size="20" color="white" >
          <v-img contain :src=partnerLogo />
        </v-avatar>
        </a>
        <span class="caption ml-1 font-weight-thin"><a target="_blank" style="color:inherit;text-decoration:inherit" :href="this.video.partner ? this.video.partner.url : 'https://www.tellmegenius.io/'"> {{ this.video.partner ? this.video.partner.name : "TellMeGenius" }} </a> | {{getViews(this.video)}} {{$t('video.views')}}</span> 
      </v-card-subtitle>


      <!-- collapse description -->
      <div>
        <v-card-actions @click="showDescription = !showDescription" class="py-0 pl-0">
          <v-btn
              id="overDetail"
              color="#363738"
              style="background-color: transparent; font-weight:800;"
              text
              class="px-0"
          >
            {{$t('common.detail')}}
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn icon>
            <v-icon>{{ showDescription ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
          </v-btn>
        </v-card-actions>

        <v-expand-transition>
          <div v-show="showDescription">
            <v-card-text class="pt-0 pb-4 px-0">
              <div>
                {{ this.video.description }}
              </div>
            </v-card-text>
          </div>
        </v-expand-transition>
      </div>
    </div>
  </v-card>
</template>

<style scoped>
.square-progress-bar,
.square-progress-bar .progress-bar {
  border-radius: 0 !important;
}
</style>

<script>
import { getThemeLogoUrl } from '@/core/utils/theme';
import { getPartnerLogoUrl } from '@/core/utils/partner';
import {getVideoPosterUrl, getReadableViews} from '@/core/utils/video';
import {userVideoSeen} from '@/core/utils/user';
import {userLastVideo} from '@/core/utils/user';
import {userVideoLastProgress} from '@/core/utils/user';
import {mapGetters} from "vuex";
import '@/assets/sass/components/video/_video-card.scss';

export default {
  name: "video-card",
  data: () => ({
    showDescription: false,
    max: 100
  }),
  props: {
    video: Object,
    theme: Object,
    routerLinkTo: Object,
    active: { type: Boolean, default: false },
    layout: { type: String, default: 'vertical' }
  },
  methods : {
    getViews(video) {return getReadableViews(video);}
  },
  computed: {
    ...mapGetters(["layoutConfig","currentUser"]),
    partnerLogo : function () {
      return getPartnerLogoUrl(this.video.partner , process.env.BASE_URL + this.layoutConfig("self.logo"));
    },
    themeLogo : function () {
      return getThemeLogoUrl(!this.theme ? this.video.theme : this.theme, process.env.BASE_URL + this.layoutConfig("self.nologo"));
    },
    videoPoster: function() {
      return getVideoPosterUrl(this.video);
    },
    seen: function () {
      return userVideoSeen(this.currentUser, this.video);
    },
    lastSeen: function () {
      return userVideoLastProgress(this.currentUser, this.video);
    },
    newVideo: function() {
      return userLastVideo(this.currentUser, this.video);
    }
  },
};
</script>
